import { render } from "./iconoLineas.vue?vue&type=template&id=23f24deb&scoped=true"
import script from "./iconoLineas.vue?vue&type=script&lang=js"
export * from "./iconoLineas.vue?vue&type=script&lang=js"

import "./iconoLineas.vue?vue&type=style&index=0&id=23f24deb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-23f24deb"

export default script